<template>
	<AdditionalLayout title="Notifications">
		<section class="section section--mini screen-start notifications">
			<Notification class="notifications__item"
			              v-for="notification in notifications"
			              :key="notification.id"
			              :notification="notification" />
		</section>
	</AdditionalLayout>
</template>
<script lang="ts" setup>
import "./NotificationsView.scss";
import AdditionalLayout from "@/layouts/AdditionalLayout/AdditionalLayout.vue";
import {onMounted, ref} from "vue";
import {NotificationEntity} from "@/entities/NotificationEntity";
import Notification from "@/components/Notification/Notification.vue";
import {useUserStore} from "@/stores/userStore";
import {useApiStore} from "@/stores/apiStore";
import {storeToRefs} from "pinia";
import {useNotificationsStore} from "@/stores/notificationsStore";

let notificationsStore = useNotificationsStore();

let {notifications} = storeToRefs(notificationsStore);

onMounted(async () => {
	await notificationsStore.readAll();
});
</script>